export default {
  "ServiceAgreement.BackButtonTitle": "戻る",
  "ServiceAgreement.DocumentTitle": "パーソナルデータの取扱いに関する同意事項",
  "Menu.Locale": "言語",
}
